// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__U_IcU","description":"styles_description__eUbur","wrapper":"styles_wrapper__fG5kX","logo":"styles_logo__VOKgL"};